module.exports = require("core-js-pure/features/instance/for-each");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/instance/for-each.js
// module id = 476
// module chunks = 13